import * as React from "react";
import Box from "@mui/material/Box";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import {createRule, getRules, updateRule} from "../../http/ruleApi";
import {UPLOAD_ROUTE} from "../../utils/constants";
import CreatableSelect, {StylesConfig} from 'react-select/creatable';



const style = {
    // position: "absolute",
    // top: "50%",
    // left: "50%",
    // transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    gap: "15px",
};

const providerStyle = {
    border: "2px solid #000",
    boxShadow: 24,
}

const ruleExample = {
    name: "Новый отчет",
    provider: "",
    state: {
        contentProvider: 0,
        songName: 0,
        singer: 0,
        album: 0,
        platform: 0,
        downloads: 0,
        relatedContentCost: 0,
        authorContentCost: 0,
        relatedLicensePrize: 0,
        authorLicensePrize: 0,
    },
};

export default function RuleSettings({
                                         rule,
                                         setRule,
                                         setOpen,
                                         setRules,
                                         rules,
                                     }) {

    const [ruleName, setRuleName] = React.useState(
        rule ? rule.rule.name : ruleExample.name
    );
    const [providerName, setProviderName] = React.useState(
        rule ? rule.provider : ruleExample.provider
    );

    const providersGroups = [...new Set(
        rules.map(currRule => (currRule.provider))
    )];

    const groups = [];
    for (const providersGroup of providersGroups) {
        groups.push({
            label: providersGroup,
            value: providersGroup
        });
    }

    const onHandleSubmit = async () => {
        const obj = {
            name: ruleName,
            state: state,
            provider: providerName
        };
        const response = rule
            ? await updateRule(rule.id, {rule: obj})
            : await createRule({rule: obj});
        // return navigate(UPLOAD_ROUTE);
        // window.location.href = UPLOAD_ROUTE;
        if(response && response[0]){
            const rows = await getRules();
            // console.log(response[0], rows);
            setRule(response[0]);
            setRules(rows);
            // setRules([...rules, response[0]]);
        }

        setOpen(false);
    };

    const [state, setState] = React.useState(
        rule ? rule.rule.state : ruleExample.state
    );

    const handleChange = (event) => {
        // console.log(event.target.name);
        let num = Number(event.target.value);
        if (isNaN(num)) num = 0;
        if (num < 0) num = 0;
        setState({
            ...state,
            [event.target.name]: num,
        });
    };

    const {
        contentProvider,
        songName,
        singer,
        platform,
        downloads,
        relatedContentCost,
        authorContentCost,
        relatedLicensePrize,
        authorLicensePrize,
        album
    } = state;

    const error =
        [
            contentProvider,
            songName,
            singer,
            album,
            platform,
            downloads,
            relatedContentCost,
            authorContentCost,
            relatedLicensePrize,
            authorLicensePrize,
        ].filter((v) => v).length < 1;

    // console.log(rule);

    return (
        <Box sx={style}>
            <TextField
                label="Название правила"
                variant="outlined"
                color="secondary"
                value={ruleName}
                onChange={(e) => setRuleName(e.target.value)}
            />
            <CreatableSelect
                closeMenuOnSelect={false}
                defaultValue={rule ? {label: rule.provider, value: rule.provider} : {label: '', value: ''}}
                options={groups}
                onChange={({label, value})=>setProviderName(value)}
                styles={{
                    control: (styles)=>({
                        ...styles,
                        color: "white",
                        backgroundColor: "#121212",
                        border: "1px solid rgba(255, 255, 255, 0.23)"
                    }),
                    input: (styles)=>({
                        ...styles,
                        color: "white",
                    }),
                    singleValue: (styles)=>({
                        ...styles,
                        color: "white",
                    }),
                    menu: (styles)=>({
                        ...styles,
                        zIndex: 100,
                    }),
                    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                        // console.log(styles);

                        return {
                            ...styles,
                            backgroundColor: "white",
                            color: "black",
                            cursor: isDisabled ? 'not-allowed' : 'default',
                            ':active': {
                                ...styles[':active'],
                                backgroundColor: "grey",
                            },
                        };
                    },
                }}
            />
            <TextField
                label="Контент-провайдер"
                variant="outlined"
                color="secondary"
                type="number"
                onChange={handleChange}
                name="contentProvider"
                value={contentProvider}
            />
            <TextField
                label="Название песни"
                variant="outlined"
                color="secondary"
                type="number"
                onChange={handleChange}
                name="songName"
                value={songName}
            />
            <TextField
                label="Альбом"
                variant="outlined"
                color="secondary"
                type="number"
                onChange={handleChange}
                name="album"
                value={album}
            />
            <TextField
                label="Исполнитель"
                variant="outlined"
                color="secondary"
                type="number"
                onChange={handleChange}
                name="singer"
                value={singer}
            />
            <TextField
                label="Платформа"
                variant="outlined"
                color="secondary"
                type="number"
                onChange={handleChange}
                name="platform"
                value={platform}
            />
            <TextField
                label="Кол-во скачиваний"
                variant="outlined"
                color="secondary"
                type="number"
                value={downloads}
                onChange={handleChange}
                name="downloads"
            />
            <TextField
                label="Ст-ть ед, контента смежные"
                variant="outlined"
                color="secondary"
                type="number"
                onChange={handleChange}
                name="relatedContentCost"
                value={relatedContentCost}
            />

            <TextField
                label="Ст-ть ед, контента авторские"
                variant="outlined"
                color="secondary"
                type="number"
                onChange={handleChange}
                name="authorContentCost"
                value={authorContentCost}
            />
            <TextField
                label="Вознаграждение Лицензиара смежные"
                variant="outlined"
                color="secondary"
                type="number"
                onChange={handleChange}
                name="relatedLicensePrize"
                value={relatedLicensePrize}
            />
            <TextField
                label="Вознаграждение Лицензиара авторские"
                variant="outlined"
                color="secondary"
                type="number"
                onChange={handleChange}
                name="authorLicensePrize"
                value={authorLicensePrize}
            />
            <Button
                disabled={error}
                variant="contained"
                color="secondary"
                onClick={onHandleSubmit}
            >
                {rule ? "Изменить правило" : "Создать правило"}
            </Button>
        </Box>
    );
}
